const eventsCode = {
  show_screen_register: '000-00-001',
  click_register_button: '000-00-002',
  show_screen_complete_register: {
    temporary: '000-00-003',
    official_success: '000-00-004',
    official_failed: '000-00-005'
  },
  click_login_button: '001-00-001',
  home: {
    show: '002-00-001',
    click_upgrade_plan_button: '002-00-002'
  },
  manage_products: {
    list_tab: {
      show: '003-01-001',
      expand_product_parent: '003-01-002',
      click_save_button: '003-01-003',
      click_save_all_button: '003-01-004',
      check_shipping_fee: '003-01-005',
      update_status_from_selling_to_stop: '003-01-006',
      update_status_from_stop_to_selling: '003-01-007',
      click_reapply_button: '003-01-008',
      click_upload_image_button: '003-01-009',
      click_search_button: '003-01-010',
      click_filter_judgment_status: '003-01-011',
      click_delete_all_button: '003-01-012',
      click_get_latest_products_button: '003-01-013',
      click_filter_stock_status: '003-01-014',
      click_delete_button: '003-01-015',
      click_show_analysis_button: '003-01-016',
      click_analysis_apply_button: '003-01-017',
      click_change_amount_received_button: '003-01-018',
      click_bulk_update_button: '003-01-019',
      click_filter_button: '003-01-020',
      click_setting_filter_button: '003-01-021',
      click_bulk_change_by_csv: '003-01-022',
      click_download_template: '003-01-023',
      click_upload: '003-01-024',
      click_submit_change_by_csv: '003-01-025'
    },
    add_by_amazon_tab: {
      show: '003-02-001',
      click_add_button: '003-02-002',
      click_add_all_button: '003-02-003',
      check_shipping_fee: '003-02-004',
      click_search_button: '003-02-005',
      click_get_latest_products_button: '003-02-006'
    },
    report_tab: {
      click_download_amazon_csv_button: '003-03-001',
      show: '003-03-002',
      click_download_yamato_csv_button: '003-03-003',
      click_download_across_csv_button: '003-03-004',
      click_download_sc_csv_button: '003-03-005'
    }
  },
  manage_revenue: {
    list_revenue_tab: {
      show: '004-01-001',
      click_download_button: '004-01-002'
    },
    history_payment_tab: {
      show: '004-02-003',
      click_download_button: '004-02-004'
    }
  },
  detail_revenue: {
    show: '005-00-001',
    click_filter_button: '005-00-002'
  },
  promotion: {
    top_tab: {
      show: '006-01-001',
      click_update_button: '006-01-002'
    },
    request_tab: {
      show: '006-02-001',
      click_filter_button: '006-02-002',
      click_delete_all_button: '006-02-003',
      click_register_new_button: '006-02-004',
      add_by_amazon_modal: {
        click_filter_button: '006-02-005',
        click_add_button: '006-02-006',
        click_reload_button: '006-02-007',
        click_add_all_button: '006-02-008'
      }
    },
    info_tab: {
      show: '006-03-001',
      click_filter_button: '006-03-002'
    }
  },
  affiliate: {
    top_tab: {
      show: '007-01-001'
    },
    list_affiliate_tab: {
      show: '007-02-001'
    },
    reward_info_tab: {
      show: '007-03-001',
      click_filter_button: '007-03-002'
    }
  },
  settings: {
    user_info_tab: {
      show: '008-01-001',
      click_update_button: '008-01-002'
    },
    login_info_tab: {
      show: '008-02-001',
      click_update_email_button: '008-02-002',
      click_update_password_button: '008-02-003',
      confirm_change_email_success: '008-02-004',
      confirm_change_email_failed: '008-02-005'
    },
    plan_info_tab: {
      show: '008-09-001',
      click_upgrade_plan_button: '008-09-002',
      upgrade_plan_completed: '008-09-003',
      upgrade_plan_cancel: '008-09-004',
      click_confirm_ussage_button: '008-09-005',
      click_receipt_button: '008-09-006',
      click_change_plan_button: '008-09-007',
      click_cancel_contract_button: '008-09-008',
      cancel_contract_completed: '008-09-009'
    },
    amazon_info_tab: {
      show: '008-03-001',
      click_link_with_amazon_button: '008-03-002'
    },
    multi_channel_service_tab: {
      show: '008-08-001',
      click_upload_button: '008-08-002'
    },
    service_info_tab: {
      show: '008-04-001',
      click_detail_button: '008-04-002',
      click_payment_from_revenue_button: '008-04-003',
      click_payment_credit_button: '008-04-004'
    },
    payment_info_tab: {
      show: '008-05-001',
      click_update_button: '008-05-002'
    },
    payment_cycle_tab: {
      show: '008-06-001',
      click_update_button: '008-06-002'
    },
    agent_notice_tab: {
      show: '008-10-001',
      click_update: '008-10-002'
    },
    other_tab: {
      click_update_received_price_button: '008-07-001',
      click_update_setting_notification_button: '008-07-002',
      show: '008-07-003'
    }
  },
  show_screen_question_and_answer: '009-00-001',
  external_services: {
    show: '010-00-001',
    show_detail: '010-00-002'
  },
  requests: {
    show: '011-00-001',
    show_detail: '011-00-002',
    click_like_button: '011-00-003',
    click_comment_button: '011-00-004',
    click_post_button: '011-00-005'
  },
  click_logout_button: '012-00-001',
  delivery_requests: {
    top_tab: {
      show: '014-00-001'
    },
    delivery_request_list_tab: {
      show: '014-01-001',
      click_register_new_button: '014-01-002',
      click_search_button: '014-01-003',
      click_update_button: '014-01-004',
      click_delete_button: '014-01-005',
      click_delivery_label_print_button: '014-01-006',
      click_product_label_print_button: '014-01-007'
    },
    delivery_request_registration_tab: {
      show: '014-02-001',
      delivery_info: {
        click_register_or_change_button: '014-02-002',
        click_register_button: '014-02-003',
        click_change_button: '014-02-004',
        click_delete_button: '014-02-005',
        click_use_button: '014-02-006'
      },
      click_register_product: '014-02-007',
      select_product_modal: {
        click_search_button: '014-02-008',
        click_add_button: '014-02-009',
        click_reload_button: '014-02-010',
        click_add_all_button: '014-02-011'
      },
      click_register_product_button: '014-02-012'
    },
    expense_detail_actual_shipment_tab: {
      show: '014-03-001',
      click_search_button: '014-03-002',
      click_download_csv_button: '014-03-003'
    },
    expense_detail_storage_fee_tab: {
      show: '014-04-001',
      click_search_button: '014-04-002',
      click_download_csv_button: '014-04-003'
    },
    usage_plan_management_tab: {
      show: '014-07-001',
      click_receipt_button: '014-07-002',
      click_link_change_usage_plan: '014-07-003'
    }
  },
  terms_of_service: {
    confirm: '013-00-001',
    agree: '013-00-002'
  },
  warehouses: {
    screen_top: '014-05-001',
    open_warehouse_management_button: '014-05-002',
    addtional_modal: {
      show: '014-05-003',
      click_additonal_button: '014-05-004'
    },
    show_registered_payment_method_page: '014-05-005',
    show_canceled_register_payment_method_page: '014-05-006',
    stop_use_confirm_modal: {
      show: '014-05-007',
      click_stop_use_button: '014-05-008'
    },
    click_regis_yamato_warehouse_button: '014-05-009',
    click_regis_across_warehouse_button: '014-05-010',
    click_regis_sc_warehouse_button: '014-05-011',
    click_update_received_amount_setting_button: '014-06-006',
    click_update_received_amount_diff_setting_button: '014-08-001'
  },
  warehouse_amazon: {
    top_tab: {
      show: '014-06-001'
    },
    amazon_info_tab: {
      show: '014-06-002',
      click_link_with_amazon_button: '014-06-003'
    },
    multi_channel_service_tab: {
      show: '014-06-004',
      click_upload_button: '014-06-005'
    }
  },
  warehouse_across: {
    top_tab: {
      show: '014-09-001'
    },
    inventory_tab: {
      show: '014-10-001',
      click_search_btn: '014-10-002',
      click_download_csv_btn: '014-10-003',
      inventory_end_of_month: {
        show: '014-20-001',
        click_download_csv_btn: '014-20-002'
      }
    },
    delivery_tab: {
      list: {
        show: '014-11-001',
        click_search_btn: '014-11-002',
        click_regis_shipping_info_btn: '014-11-003',
        click_edit_btn: '014-11-004',
        click_delete_btn: '014-11-005',
        click_coppy_btn: '014-11-006'
      },
      direct_delivery: {
        show: '014-12-001',
        click_regis_or_update_shipping_info_btn: '014-12-002',
        click_regis_shipping_info_btn: '014-12-003',
        click_update_shipping_info_btn: '014-12-004',
        click_delete_shipping_info_btn: '014-12-005',
        click_use_shipping_info_btn: '014-12-006',
        click_select_product_btn: '014-12-007',
        click_update_inventory_btn: '014-12-008',
        click_search_btn: '014-12-009',
        click_add_product_btn: '014-12-010',
        click_add_products_btn: '014-12-011',
        click_request_delivery_btn: '014-12-012',
        click_upload_by_csv: '014-12-013',
        click_download_template: '014-12-014',
        click_upload: '014-12-015'
      },
      amazon_delivery: {
        show: '014-13-001',
        click_select_product_btn: '014-13-002',
        click_update_inventory_btn: '014-13-003',
        click_search_btn: '014-13-004',
        click_add_product_btn: '014-13-005',
        click_add_products_btn: '014-13-006',
        click_request_delivery_btn: '014-13-007'
      }
    },
    shipping_tab: {
      list: {
        show: '014-14-001',
        click_search_btn: '014-14-002',
        click_show_shipping_info_btn: '014-14-003',
        click_edit_btn: '014-14-004',
        click_delete_btn: '014-14-005',
        click_coppy_btn: '014-14-006'
      },
      amazon_shipping: {
        show: '014-15-001',
        click_select_product_btn: '014-15-002',
        click_update_inventory_btn: '014-15-003',
        click_search_btn: '014-15-004',
        click_add_product_btn: '014-15-005',
        click_add_products_btn: '014-15-006',
        click_request_shipping_btn: '014-15-007',
        click_display_by_exp_date_link: '014-15-008'
      },
      yamato_shipping: {
        show: '014-16-001',
        click_select_product_btn: '014-16-002',
        click_search_btn: '014-16-003',
        click_add_product_btn: '014-16-004',
        click_add_products_btn: '014-16-005',
        click_display_by_exp_date_link: '014-16-006',
        click_request_shipping_btn: '014-16-007'
      },
      sc_shipping: {
        show: '014-21-001',
        click_select_product_btn: '014-21-002',
        click_search_btn: '014-21-003',
        click_add_product_btn: '014-21-004',
        click_add_products_btn: '014-21-005',
        click_display_by_exp_date_link: '014-21-006',
        click_request_shipping_btn: '014-21-007'
      },
      multi_channel_shipping: {
        show: '014-17-001',
        click_regis_or_update_shipping_info_btn: '014-17-002',
        click_regis_shipping_info_btn: '014-17-003',
        click_update_shipping_info_btn: '014-17-004',
        click_delete_shipping_info_btn: '014-17-005',
        click_use_shipping_info_btn: '014-17-006',
        click_input_receipt_info_btn: '014-17-007',
        click_regis_receipt_info_btn: '014-17-008',
        click_select_product_btn: '014-17-009',
        click_search_btn: '014-17-010',
        click_add_product_btn: '014-17-011',
        click_add_products_btn: '014-17-012',
        click_request_shipping_btn: '014-17-013'
      }
    },
    expense_details_tab: {
      shipping_cost: {
        show: '014-18-001',
        click_search_btn: '014-18-002',
        click_download_btn: '014-18-003'
      },
      other_cost: {
        show: '014-18-004',
        click_search_btn: '014-18-005',
        click_download_btn: '014-18-006'
      }
    },
    setting_tab: {
      price_diff: {
        click_update_across_diff: '014-19-001'
      }
    }
  },
  warehouse_sc: {
    top_tab: {
      show: '014-22-001'
    },
    inventory_tab: {
      show: '014-22-002',
      click_search_btn: '014-22-003',
      click_download_csv_btn: '014-22-004',
      inventory_end_of_month: {
        show: '014-22-005',
        click_download_csv_btn: '014-22-009'
      }
    },
    delivery_tab: {
      show: '014-22-006'
    },
    shipping_tab: {
      list: {
        show: '014-22-016',
        click_search_btn: '014-22-017',
        click_show_shipping_info_btn: '014-22-018',
        click_delete_btn: '014-22-019',
        click_coppy_btn: '014-22-020'
      },
      multi_channel_shipping: {
        show: '014-22-021',
        click_regis_or_update_shipping_info_btn: '014-22-022',
        click_regis_shipping_info_btn: '014-22-023',
        click_update_shipping_info_btn: '014-22-024',
        click_delete_shipping_info_btn: '014-22-025',
        click_use_shipping_info_btn: '014-22-026',
        click_input_receipt_info_btn: '014-22-027',
        click_regis_receipt_info_btn: '014-22-028',
        click_select_product_btn: '014-22-029',
        click_search_btn: '014-22-030',
        click_add_product_btn: '014-22-031',
        click_add_products_btn: '014-22-032',
        click_request_shipping_btn: '014-22-033'
      }
    },
    expense_details_tab: {
      shipping_cost: {
        show: '014-22-010',
        click_search_btn: '014-22-011',
        click_download_btn: '014-22-012'
      },
      other_cost: {
        show: '014-22-013',
        click_search_btn: '014-22-014',
        click_download_btn: '014-22-015'
      }
    },
    setting_tab: {
      show: '014-22-007',
      click_update_btn: '014-22-008'
    }
  },
  salemon_agent: {
    longterm: {
      show: '018-00-001',
      click_start_delivery: '018-00-002'
    },
    product_available: {
      show: '018-02-001',
      click_regis_list_btn: '018-02-002',
      click_disable_notify_list_btn: '018-02-003',
      click_regis_btn: '018-02-004',
      click_disable_notify_btn: '018-02-005'

    },
    settings: {
      show: '018-01-001',
      click_update: '018-01-002'
    }
  },
  premium: {
    show: '015-00-001'
  },
  help: {
    list: '016-00-001',
    show: '016-00-002'
  },
  analysis: {
    show: '017-00-001'
  },
  video: {
    list: '019-00-001',
    search: '019-00-002',
    play: '019-01-001',
    like: '019-01-002',
    comment: '019-01-003',
    like_comment: '019-01-004'
  },
  sale: {
    open: '020-01-001',
    entry: {
      show: '020-02-001',
      product_list: {
        search: '020-02-002',
        add_all: '020-02-003',
        add: '020-02-004'
      },
      list_input: {
        add: '020-02-005',
        download_report: '020-02-006'
      },
      upload: {
        download_template: '020-02-007',
        add: '020-02-008',
        download_report: '020-02-009'
      },
      delete_all: '020-02-010',
      delete: '020-02-011',
      submit: '020-02-012',
      download: '020-02-013'
    },
    history: {
      show: '020-03-001',
      download: '020-03-002',
      edit: '020-03-003',
      cancel: '020-03-004'
    },
    closed: '020-04-001'
  }
}

export default eventsCode



// WEBPACK FOOTER //
// ./src/common/event-code.js